import { range } from 'utils/range';

export const availableEmojis = range(0x1f600, 0x1f620).map((code) => String.fromCodePoint(code));
